<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <el-form
          label-position="top"
          label-width="80px"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓">
                <el-input
                  v-model="form.last_name"
                  placeholder="请输入姓"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名">
                <el-input
                  v-model="form.first_name"
                  placeholder="请输入名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="公司">
            <el-input
              v-model="form.company"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              placeholder="请输入联系方式"
              v-model="form.contact"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行收款信息" prop="bank_payment_info">
            <el-input
              type="textarea"
              placeholder="请填写真实姓名及地址"
              v-model="form.bank_payment_info"
              :rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form></el-col
      >
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '非会员',
        },
        {
          value: '选项2',
          label: '网红',
        },
        {
          value: '选项3',
          label: '套餐A',
        },
        {
          value: '选项4',
          label: '套餐B',
        },
      ],
      rules: {
        username: [
          { required: false, message: '请输入会员名称', trigger: 'change' },
        ],
        company: [
          { required: false, message: '请输入公司名称', trigger: 'change' },
        ],
        contact: [
          { required: false, message: '请输入联系方式', trigger: 'change' },
        ],
      },
      btnLoading: false,
      form: {
        value: '',
        name: '',
        region: '',
        last_name: '',
        first_name: '',
        type: '',
        bank_payment_info: '',
      },
    }
  },
  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.id) {
      this.getuserinfo(this.$route.query.id)
    }
    this.getvipProduct()
  },
  methods: {
    back() {
      this.$router.back()
    },
    getuserinfo(id) {
      this.form.id = id
      request({
        url: '/api/backend/users/detail',
        method: 'get',
        params: {
          id: id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
    getvipProduct() {
      request({
        url: '/api/backend/vipProduct/list',
        method: 'get',
      }).then((response) => {
        this.vipProductlist = response.data.data
      })
    },
    store() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/vip/infoStore',
            method: 'post',
            data: {
              id: this.form.id,
              username: this.form.username,
              email: this.form.email,
              password: this.form.password,
              company: this.form.company,
              contact: this.form.contact,
              first_name: this.form.first_name,
              last_name: this.form.last_name,
              user_type: this.form.user_type,
              vip_point: this.form.vip_point,
              parent_invite_code: this.form.parent_invite_code,
              vip_product_id: this.form.vip_product_id,
              bank_payment_info: this.form.bank_payment_info,
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/member/memberlist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
